import { createRouter, createWebHistory } from 'vue-router'

// router/index.ts
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
NProgress.configure({
    showSpinner: false,
});

const router = createRouter({
    history: createWebHistory(
        import.meta.env.BASE_URL),
    routes: [{
            path: '/',
            name: '/',
            component: () =>
                import ('../views/index.vue'),
        },
        {
            path: '/market',
            redirect: '/',
            children: [{
                    path: 'overallData',
                    name: '市场数据 - 市场整体概况',
                    component: () =>
                        import ('../views/market/overallData/overallData.vue'),
                },
                {
                    path: 'businessData',
                    name: '市场数据 - 务条线数据',
                    component: () =>
                        import ('../views/market/businessData/businessData.vue'),
                },
                {
                    path: 'resourceData',
                    name: '市场数据 - 资源渠道数据',
                    component: () =>
                        import ('../views/market/resourceData/resourceData.vue'),
                },
                {
                    path: 'signData',
                    name: '市场数据 - 签约业务类型',
                    component: () =>
                        import ('../views/market/signData/signData.vue'),
                },
                {
                    path: 'channelData',
                    name: '市场数据 - 渠道细分',
                    component: () =>
                        import ('../views/market/channelData/channelData.vue'),
                }
            ]
        },
        {
            path: '/network',
            redirect: '/',
            children: [{
                    path: 'overall',
                    name: '/network/overall',
                    component: () =>
                        import ('../views/network/overall/overall.vue'),
                },
                {
                    path: 'company',
                    name: '/network/company',
                    component: () =>
                        import ('../views/network/company/company.vue'),
                },
                {
                    path: 'pipeline',
                    name: '/network/pipeline',
                    component: () =>
                        import ('../views/network/pipeline/pipeline.vue'),
                },
                {
                    path: 'company-budget',
                    name: '网络数据 - 分公司预算进度',
                    component: () =>
                        import ('../views/network/companyBudget/companyBudget.vue'),
                },
                {
                    path: 'signCrowd',
                    name: '网络数据 - 签约人群画像',
                    component: () =>
                        import ('../views/network/signCrowd/signCrowd.vue'),
                }
            ]
        },
        {
            path: '/website',
            redirect: '/',
            children: [{
                    path: 'network',
                    name: '/website/network',
                    component: () =>
                        import ('../views/website/network/network.vue'),
                },
                {
                    path: 'companyOperate',
                    name: '/website/companyOperate',
                    component: () =>
                        import ('../views/website/companyOperate/companyOperate.vue'),
                },
                {
                    path: 'companyContent',
                    name: '/website/companyContent',
                    component: () =>
                        import ('../views/website/companyContent/companyContent.vue'),
                },
                {
                    path: 'article',
                    name: '/website/article',
                    component: () =>
                        import ('../views/website/article/article.vue'),
                },
                {
                    path: 'line',
                    name: '条线专题数',
                    component: () =>
                        import ('../views/website/line/index.vue'),
                }
            ]
        },
        {
            path: '/highSchool',
            redirect: '/',
            children: [{
                    path: 'marketHighSchool',
                    name: '高校数据 - 高校数据',
                    component: () =>
                        import ('../views/highSchool/marketHighSchool/marketHighSchool.vue'),
                },
                {
                    path: 'marketHighSchoolOfficial',
                    name: '高校数据 - 官方合作',
                    component: () =>
                        import ('../views/highSchool/marketHighSchoolOfficial/marketHighSchoolOfficial.vue'),
                },
                {
                    path: 'attribute',
                    name: '高校数据 - 高校属性',
                    component: () =>
                        import ('../views/highSchool/attribute/attribute.vue'),
                },
                {
                    path: 'activity',
                    name: '高校数据 - 高校活动',
                    component: () =>
                        import ('../views/highSchool/activity/activity.vue'),
                },
            ]
        },
        {
            path: '/operation',
            redirect: '/',
            children: [{
                    path: 'rdAccountData',
                    name: '运营数据 - 小红书账号数据',
                    component: () =>
                        import ('../views/operation/rdAccountData/rdAccountData.vue'),
                },
                {
                    path: 'rdNoteData',
                    name: '运营数据 - 小红书笔记数据',
                    component: () =>
                        import ('../views/operation/rdNoteData/rdNoteData.vue'),
                },
                {
                    path: 'shopEvaluateData',
                    name: '运营数据 - 门店评价',
                    component: () =>
                        import ('../views/operation/shopEvaluateData/shopEvaluateData.vue'),
                },
                {
                    path: 'dyTtData',
                    name: '运营数据 - 抖音/头条数据',
                    component: () =>
                        import ('../views/operation/dyTtData/dyTtData.vue'),
                },
                {
                    path: 'trafficInsights',
                    name: '运营数据 - 流量洞察',
                    component: () =>
                        import ('../views/operation/trafficInsights/trafficInsights.vue'),
                },
                {
                    path: 'mtShop',
                    name: '运营数据 - 门店运营数据',
                    component: () =>
                        import ('../views/operation/mtShop/mtShop.vue'),
                }
            ]
        },
        {
            path: '/wxCenter',
            redirect: '/',
            children: [{
                    path: 'prize',
                    name: '个人中心 - 奖品页面',
                    component: () =>
                        import ('../views/wxCenter/prize/prize.vue'),
                },
                {
                    path: 'prizeRecord',
                    name: '个人中心 - 中奖记录',
                    component: () =>
                        import ('../views/wxCenter/prizeRecord/prizeRecord.vue'),
                }
            ]
        },
        {
            path: '/resource',
            redirect: '/',
            children: [{
                    path: 'formdata',
                    name: '/resource/formdata',
                    component: () =>
                        import ('../views/resource/formdata/formdata.vue'),
                },
                {
                    path: 'clue',
                    name: '/resource/clue',
                    component: () =>
                        import ('../views/resource/clue/clue.vue'),
                }
            ]
        },
        {
            path: '/gaoxiao',
            redirect: '/',
            children: [{
                    path: 'accessLearn',
                    name: '/gaoxiao/accessLearn',
                    component: () =>
                        import ('../views/gaoxiao/accessLearn/accessLearn.vue'),
                },
                {
                    path: 'projectTopic',
                    name: '/gaoxiao/projectTopic',
                    component: () =>
                        import ('../views/gaoxiao/projectTopic/projectTopic.vue'),
                },
                {
                    path: 'hotProject',
                    name: '热报项目',
                    component: () =>
                        import ('../views/gaoxiao/hotProject/hotProject.vue'),
                },
                {
                    path: 'projectManage',
                    name: '/gaoxiao/projectManage',
                    component: () =>
                        import ('../views/gaoxiao/projectManage/projectManage.vue'),
                },
                {
                    path: 'schoolManage',
                    name: '/gaoxiao/schoolManage',
                    component: () =>
                        import ('../views/gaoxiao/schoolManage/schoolManage.vue'),
                },
                {
                    path: 'applicationManage',
                    name: '/gaoxiao/applicationManage',
                    component: () =>
                        import ('../views/gaoxiao/applicationManage/applicationManage.vue'),
                }
            ]
        },
        {
            path: '/education',
            redirect: '/',
            children: [{
                path: 'source',
                name: '全球教育路径-资源',
                component: () =>
                    import ('../views/education/source/source.vue'),
            }]
        },
        {
            path: '/promotion',
            redirect: '/',
            children: [{
                    path: 'medium',
                    name: '/promotion/medium',
                    component: () =>
                        import ('../views/promotion/medium/medium.vue'),
                },
                {
                    path: 'budget',
                    name: '/promotion/budget',
                    component: () =>
                        import ('../views/promotion/budget/budget.vue'),
                },
                {
                    path: 'cost',
                    name: '/promotion/cost',
                    component: () =>
                        import ('../views/promotion/cost/cost.vue'),
                },
                {
                    path: 'agent',
                    name: '/promotion/agent',
                    component: () =>
                        import ('../views/promotion/agent/agent.vue'),
                },
                {
                    path: 'field',
                    name: '/promotion/field',
                    component: () =>
                        import ('../views/promotion/field/field.vue'),
                },
                {
                    path: 'upload',
                    name: '/promotion/upload',
                    component: () =>
                        import ('../views/promotion/upload/upload.vue'),
                },
                {
                    path: 'email',
                    name: '/promotion/email',
                    component: () =>
                        import ('../views/promotion/email/email.vue'),
                },
                {
                    path: 'keyword',
                    name: '/promotion/keyword',
                    component: () =>
                        import ('../views/promotion/keyword/keyword.vue'),
                }
            ]
        },
        {
            path: '/management',
            redirect: '/',
            children: [{
                    path: 'role',
                    name: '/management/role',
                    component: () =>
                        import ('../views/management/role/role.vue'),
                },
                {
                    path: 'authority',
                    name: '/management/authority',
                    component: () =>
                        import ('../views/management/authority/authority.vue'),
                },
                {
                    path: 'member',
                    name: '/management/member',
                    component: () =>
                        import ('../views/management/member/member.vue'),
                },
                {
                    path: 'company',
                    name: '/management/company',
                    component: () =>
                        import ('../views/management/company/company.vue'),
                },
                {
                    path: 'menulist',
                    name: '/management/menulist',
                    component: () =>
                        import ('../views/management/menulist/menulist.vue'),
                }
            ]
        },
        {
            path: '/demo',
            name: 'demo',
            component: () =>
                import ('../views/demo/demo.vue')
        },
        {
            path: '/login',
            name: 'login',
            component: () =>
                import ('../views/login/login.vue')
        },
        {
            path: '/:catchAll(.*)',
            component: () =>
                import ('../views/error/error.vue')
        }
    ]
})

// 全局前置守卫，这里可以加入用户登录判断
router.beforeEach((to, from, next) => {
    NProgress.start() // 进度条开始
    next()
})

router.afterEach(() => {
    NProgress.done() // 进度条结束
})

export default router